import { Component, OnInit } from '@angular/core';

import { Platform } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { MenuController } from '@ionic/angular'; //import MenuController to access toggle() method.
import { GlobleSettingsService } from './service/globle-settings.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss']
})
export class AppComponent implements OnInit {
  public selectedIndex = 0;
  public screenSaver = false;

  public appPages = [
    {
      title: 'Digital Flipbook',
      url: 'osa-treatment',
    },
    {
      title: 'Video Series',
      url: 'admin-dash/saved-playlist',
    }
  ];
  currentUrl:string = "";

  constructor(
    private platform: Platform,
    private splashScreen: SplashScreen,
    private statusBar: StatusBar,
    public menuCtrl: MenuController,
    public http: HttpClient,
    public globlesetting: GlobleSettingsService,
    private router: Router
  ) {
    
    this.router.events.pipe(
      filter((event) => event instanceof NavigationEnd)
    ).subscribe((event: any) => {
      this.currentUrl = this.router.url;
    });
    this.initializeApp();
  }

  initializeApp() {
    this.platform.ready().then(() => {
      this.statusBar.styleDefault();
      // this.splashScreen.hide();
    });
  }

  ngOnInit() {
    console.log(this.globlesetting.isHeader); 
    this.deviceInfoUpdate();
  }

  deviceInfoUpdate() {
    setInterval(() => {
      if(localStorage.getItem('currentUser')){
        // For web Broswer 
        if(!this.globlesetting.isBrowserDevice){
          this.globlesetting.getDeviceInfo();
        }
      }
    }, 10000);
  }

  toggleMenu() {
    this.menuCtrl.toggle(); //Add this method to your button click function
  }

  screenSaverChange(event) {
    console.log(this.screenSaver);
    var screenSaverUrl = '';

    // cmd=setBooleanSetting&key=screensaverEnabled&value=true|false&password=[pass]
    if(this.screenSaver){
      screenSaverUrl = 'http://localhost:2424/?cmd=setBooleanSetting&key=screensaverEnabled&value=true&password=sunshineinparis&type=json';
    }else{
      screenSaverUrl = 'http://localhost:2424/?cmd=setBooleanSetting&key=screensaverEnabled&value=false&password=sunshineinparis&type=json';
    }
    console.log(screenSaverUrl);

    const headers = new HttpHeaders();
    headers.append("Accept", 'application/json');
    headers.append('Content-Type', 'application/json' );
    const options =  ({
      headers: headers
    });

    this.http.get(screenSaverUrl, options).subscribe(data => {
      console.log('Done');
      console.log(data);
      }, error => {
      console.log(error);
    });
  }
}
